import { render, staticRenderFns } from "./Speaker.vue?vue&type=template&id=66641196&scoped=true&"
import script from "./Speaker.vue?vue&type=script&lang=ts&"
export * from "./Speaker.vue?vue&type=script&lang=ts&"
import style0 from "./Speaker.vue?vue&type=style&index=0&id=66641196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66641196",
  null
  
)

export default component.exports